import React from 'react'
import Header_Footer from '../Layout/Header_Footer'

const About = () => {
  return (
    <Header_Footer>
      <h1>About</h1>
    </Header_Footer>
  )
}

export default About
